import { FC, PropsWithChildren } from "react";

import { css, Global } from "@emotion/react";
import { ComponentsThemeProvider } from "@hl/base-components/lib/theme/provider";
import { useAccountSettings } from "@hl/shared-features/lib/features/auth/hooks/useAccountSettings";

import {
  BackgroundType,
  CornersShape,
  PageTheme,
} from "apollo/graphql.generated";
import { CustomLegacyTheme } from "styles/theme/types";

import fonts from "../fonts";

import { legacyTheme } from "./legacy";

const globalStyles = css`
  ${fonts}

  html, body {
    height: 100%;
  }

  #root {
    height: 100%;
    display: flex;
    flex-direction: column;

    > * {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }
  }

  //FIXME: Can be removed if Editor buttons are refactored to disregard CSS resets
  button {
    border: 0;
    padding: 0;
    background-color: transparent;
    font: inherit;
    color: inherit;
    cursor: pointer;
    margin: 0;
  }
`;

export const AppThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  // TODO: Is this needed?
  useAccountSettings();

  return (
    <ComponentsThemeProvider
      legacyTheme={defaultLegacyTheme}
      enableDarkMode={true}
    >
      <Global styles={globalStyles} />
      {children}
    </ComponentsThemeProvider>
  );
};

export const defaultPageTheme: PageTheme = {
  background: {
    type: BackgroundType.Solid,
    color: "#FFFFFF",
  },
  text: {
    fontFamily: "Inter",
    color: "#000000",
  },
  title: {
    fontFamily: "Inter",
  },
  corners: {
    shape: CornersShape.Rounded,
  },
};

export const defaultLegacyTheme: CustomLegacyTheme = {
  ...legacyTheme,
  page: {
    background: {
      type: BackgroundType.Solid,
      color: "#FFFFFF",
    },
    text: {
      fontFamily: legacyTheme.text.fontFamily.primary,
      color: "#000000",
    },
    title: {
      fontFamily: legacyTheme.title.fontFamily,
    },
    corners: {
      shape: CornersShape.Rounded,
    },
  },
};

export const Z_INDEX = Object.freeze({
  editorToolbar: 1,
  sidebar: 101,
  modalOverlay: 200,
});
